
import React from "react";

import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import Select from "react-select";
import { Input } from "../../../_metronic/_partials/controls";


const CategoryEditSchema = Yup.object().shape({
  category_name: Yup.string()
    .min(2, "Minimum 2 symbols")
    .max(50, "Maximum 50 symbols")
    .required("Category name is required"),
  order: Yup.string()
    .min(1, "Minimum 1 symbol")
    .max(50, "Maximum 50 symbols")
    .required("Category order is required")

});

export function CategoryEditForm({ category, role, id, total, btnRef, saveCategory }) {

  const options = [];
  for (var i = 1; i <= total; i++) {

    var obj = {};
    obj.value = i;
    obj.label = i;
    options.push(obj);
  }
  return (
    <>
      <Formik
        enableReinitialize={true}
        initialValues={category}
        validationSchema={CategoryEditSchema}
        onSubmit={async (values, { setErrors }) => {
          const body = {
            id: parseInt(id),
            order: values.order
          }
          await saveCategory(body);
        }}>
        {({ handleSubmit, field, setFieldValue, values, handleChange }) => (
          <>
            <Form className='form form-label-right'>

              <div className='form-group row mt-5'>
                <Field
                  name="category_name"
                  component={Input}
                  placeholder='Category Name'
                  label="Category Name"
                  readonly="true"
                />
              </div>

              <div className='form-group row mt-5'>
                <label className="col-xl-3 col-lg-2 col-form-label text-right">Category Ordering</label>
                <div className="col-lg-6 col-xl-6">
                  <Select
                    classNamePrefix='selected ordering'
                    options={options}
                    name='order'
                    onChange={async (selectedOption) => {
                      setFieldValue(
                        "order",
                        selectedOption.value
                      );
                    }}
                    value={options?.filter(function (option) {
                      return option.value == values.order;
                    })}
                  />
                </div>
              </div>

              <button
                type='submit'
                style={{ display: "none" }}
                ref={btnRef}
                onSubmit={() => handleSubmit()}>
              </button>

            </Form>
          </>
        )}
      </Formik>
    </>
  );
}
